import "../_tmpl";
import { keyBy } from "lodash";
import { renderFieldWidget, runWidgetFunction } from "../../utils/widget";

/* eslint-disable */

(function ($) {
    $.widget('ep.base_record_field', {
        options: {
            resources: {
                validationRequired: 'This field is required.'
            },
            model: {},
            templateId: null,
            baseTemplateId: 'form-record-field-base',
            // used only by Dropdown/CheckboxList/RadiobuttonList fields;
            // key is FieldID, value is its conditional children.
            fields: {},
        },

        prepareDataForOverride: function (model) { },

        _create: function () {
            this._model = this.options.model;
            this.children = [];
            this._applyTemplate();

            this.setValues();
        },

        _applyTemplate: function () {
            var _this = this;
            var templateData = this.prepareData(this._model);
            this.element.empty();

            // Apply field wrapper template
            $.tmpl('#' + this.options.baseTemplateId, templateData).appendTo(this.element);
            var fieldContainer = $('.field-container', this.element);

            // Apply field template.
            $.tmpl("#" + this.options.templateId, templateData).appendTo(fieldContainer);

            // Handle deletion.
            $('.delete-checkbox', this.element).change(function () {
                _this._model.Remove = $(this).prop("checked");
            });

            this.afterRenderTemplate();

            // hide if it's non visible conditional field
            this.updateVisibility();

            // Make deleted fields readonly
            if (this._model.Deleted) {
                this.setDisabled();
            }

            // conditional fields exist only for Dropdown/CheckboxList/RadiobuttonList fields
            if (!!this.options.model.Options) {
                this.renderChildren();
            }
        },

        /**
         *
         * @param {Array} serverItems - array of objects with properties: FieldID, ValidationError
         */
        applyValidationResult: function (serverItems) {
            let item = serverItems.find(x => x.FieldID === this._model.FieldID && !!x.ValidationError);

            if (item) {
                $('.hint', this.element).hide();

                var decodedText = ep.common.htmlDecode(this.options.resources[item.ValidationError]);
                $('.validation-error', this.element).html(decodedText).show();
            }

            this.children.forEach(runWidgetFunction("applyValidationResult", serverItems));
        },

        clearValidationResult: function () {
            $('.hint', this.element).show();

            // Hide server validation message
            $('.validation-error', this.element).hide();

            //Hide client validation message
            $('label.error', this.element).hide();
        },

        setValues: function () {
        },

        getData: function () {
            return this._model;
        },

        getBranchData: function () {
            this.getData();
            return [this._model, ...this.children.flatMap(runWidgetFunction("getBranchData"))];
        },

        setDisabled: function () {
            $('.field-container input', this.element).prop('disabled', true);
        },

        validate: function () {
            return true;
        },

        errorPlacement: function (error, element) {
            if (this.element.has(element).length > 0) {
                error.insertAfter(element);
            }

            this.children.forEach(runWidgetFunction("errorPlacement", error, element));
        },

        afterRenderTemplate: function () {

        },

        prepareData: function () {
            var objectToBind = {
                Resources: this.options.resources,
                Item: this.options.model,
                Mode: this.options.mode
            };

            this.prepareDataForOverride(objectToBind);

            return objectToBind;
        },

        renderChildren: function() {
            const { model: { FieldID }, fields } = this.options;

            this.children = (fields[FieldID] || []).map(child =>
                renderFieldWidget(this.element.parent(), {
                    ...this.options,
                    model: { ...child, Remove: this.isHidden(child) },
                })
            );
        },

        /**
         * @param {import("../../utils/widget").Field} child
         */
        isHidden: function({ Condition: { OptionId } }) {
            let { model: { Options, Values, Remove: isParentHidden } } = this.options;
            this.optionsById = this.optionsById || keyBy(Options, "Id");
            let isOptionSelected = this.optionsById[OptionId] && Values.includes(this.optionsById[OptionId].Name);

            return isParentHidden || !isOptionSelected;
        },

        /**
         * @param {Function} isHiddenFn - returns true if field should be hidden because of parent's state
         */
        updateBranchVisibility: function(isHiddenFn) {
            if (isHiddenFn) {
                this.options.model.Remove = isHiddenFn(this.options.model);
                this.updateVisibility();
            }

            this.children.forEach(runWidgetFunction("updateBranchVisibility", this.isHidden.bind(this)));
        },

        updateVisibility: function() {
            $('.field-container input, select, textarea', this.element)
                // enable or disable validation
                .attr('disabled', this.options.model.Remove)
                // recalc chzn state for select
                .trigger("liszt:enableupdated");

            // show or hide field's <li/>
            this.element[this.options.model.Remove ? "addClass" : "removeClass"]("hidden");
        },

        destroy: function () {
            this.children.forEach(runWidgetFunction("destroy"));
            this.element.empty();
            // Call the base destroy function
            $.Widget.prototype.destroy.call(this);
        }
    });
})(jQuery);
/* eslint-enable */
